import ContainerTitle from "../component/ContainerTitle";
import HomeTable from "./HomeTable";

const Home = () => {
  return (
    <ContainerTitle name="HOMES">
      <HomeTable />
    </ContainerTitle>
  );
};

export default Home;
